import { useQueryClient, useMutation } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { EdgeLocationUpdate } from '@cast/types-omni';

import { getClusterEdgeLocationsQueryKey } from 'hooks/queries/omni/useGetClusterEdgeLocationsQuery';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

type UseUpdateEdgeLocationMutationProps = {
  edgeLocationId: string;
  clusterId: string;
  onSuccess?: () => void;
};

export const useUpdateEdgeLocationMutation = ({
  edgeLocationId,
  clusterId,
  onSuccess,
}: UseUpdateEdgeLocationMutationProps) => {
  const queryClient = useQueryClient();
  const { currentOrganization } = useOrganizations();

  return useMutation({
    mutationFn: (edgeLocation: EdgeLocationUpdate) => {
      return apiClient.omni.updateEdgeLocation({
        organizationId: currentOrganization!.id,
        clusterId,
        id: edgeLocationId,
        edgeLocationUpdate: edgeLocation,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getClusterEdgeLocationsQueryKey({ clusterId }),
      });
      notify.success('Edge location updated successfully!');
      onSuccess?.();
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
